import { json } from 'react-router-dom';
import { AdminUser, CustomPrompts } from '../types/types';
import { API_BASE_URL } from '../services/APIService';

export const CustomPromptsForUserLoader = async (user_id: string): Promise<CustomPrompts> => {
  const accessToken = localStorage.getItem('accessToken');
  const customPrompts = await fetch(
    `${API_BASE_URL}/user/getCustomPromptsForUser?user_id=${user_id}`,
    {
      method: 'get',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      }),
    },
  )
    .then(res => {
      if (res.status === 401) {
        throw json(
          {
            message: 'You are not authorized to access this resource.',
            cta: 'Login',
          },
          { status: 401 },
        );
      }

      return res.json();
    })
    .then((data: { custom_prompts: CustomPrompts }) => {
      return data.custom_prompts;
    })
    .catch(e => {
      console.error(e);
      throw json(
        {
          message: 'There has been an error. Please login again.',
          cta: 'Login',
        },
        { status: 500 },
      );
    });

  return customPrompts;
};
